<template>
  <div class="width98 margin-auto">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <div
      class="width100 backwhite"
      style="min-height: calc(100vh - 110px)"
      v-if="searchcont"
    >
      <div class="width30 margin-auto" style="padding-top: 22vh">
        <img class="width85" src="@/assets/barsvg/2@2x (1).png" alt="" />
      </div>
      <div class="margin-top40">
        <el-input
          class="width60 Keywordsinput cursorpointer"
          placeholder="请输入商标名称检索"
          v-model="input2"
        >
          <template slot="append">
            <span @click="searchclick">检索</span></template
          >
        </el-input>
      </div>

      <p class="searchchange cursorpointer margin-right50" @click="changecont">
        表格检索 <i slot="prefix" class="el-icon-arrow-right"></i>
      </p>
      <div
        class="width56 margin-auto margin-top20 cursorpointer"
        style="position: relative; left: -3.2%"
        @click="toThroughrate"
      >
        <img class="width100" src="@/assets/barsvg/banner@2x.png" alt="" />
      </div>
    </div>
    <div class="width100" v-if="maincont">
      <!-- 检索 -->
      <div
        class="backwhite border-rd3 flexleft pad-top10 pad-bot10"
        style="min-height: 72px"
        v-if="serchkey"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          size="small"
          class="demo-ruleForm width100 flexleft"
        >
          <el-form-item label="检索模式">
            <el-select
              v-model="ruleForm.query_type"
              placeholder="请选择检索模式"
              :filterable="true"
              class="width100"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商标名称 ">
            <el-input
              placeholder="请输入商标名称"
              v-model="ruleForm.trademark_name"
            ></el-input> </el-form-item
          ><el-form-item label="代理机构名称 ">
            <el-input
              placeholder="请输入代理机构名称"
              v-model="ruleForm.agent_name"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册人名称 ">
            <el-input
              placeholder="请输入注册人名称"
              v-model="ruleForm.register"
            ></el-input> </el-form-item
          ><el-form-item label="注册人地址 ">
            <el-input
              placeholder="请输入注册人地址"
              v-model="ruleForm.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="商标注册号 ">
            <el-input
              placeholder="请输入商标注册号"
              v-model="ruleForm.reg_number"
            ></el-input>
          </el-form-item>
          <el-form-item label="国际分类号 ">
            <el-input
              placeholder="请输入国际分类号"
              v-model="ruleForm.international_class"
            ></el-input>
          </el-form-item>
          <div class="margin-left20 margin-top5 margin-bot10">
            <el-button type="primary" size="mini" @click="submitForm()"
              >检 索</el-button
            >
            <el-button class="resetbtn" size="mini" @click="resetForm()"
              >重 置</el-button
            >
          </div>
        </el-form>
      </div>

      <div
        class="
          width100
          backwhite
          pad-bot20
          margin-auto margin-top15
          border-rd3
          alldigital
        "
        v-if="total != 0"
      >
        <el-table
          :data="pages"
          stripe
          style="width: 98%"
          class="eltable margin-auto margin-top20 f14"
        >
          <el-table-column label="商标名称">
            <template slot-scope="scope">
              <span
                class="f14 cursorpointer bluecolor text-ellipsis"
                @click="todetails(scope.row)"
              >
                {{ scope.row.TrademarkName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="InternationalClass" label="国际分类">
          </el-table-column>
          <el-table-column prop="RegNumber" label="商标号码"> </el-table-column>
          <el-table-column prop="ApplyDate" label="申请日期"> </el-table-column>
          <el-table-column prop="RegisterName" label="注册人名称">
          </el-table-column>
          <el-table-column prop="IsWellKnown" label="是否驰名商标">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                style="color: #52c5cb"
                class="f14 cursorpointer"
                @click="addteadmarkfollow(scope.row)"
              >
                加入关注
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="flex-betweennowrap pad-top20 pad-right10" v-if="total != 0">
          <span class="bluecolor"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="parseInt(per_page)"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>
      <div
        class="width100 margin-auto backgroudFFF margin-top15"
        v-if="total == 0"
      >
        <el-empty
          :image="require('@/assets/barsvg/zwsj@3x.png')"
          :image-size="200"
          description="抱歉，没有搜到您想要的内容"
          class="heightempty"
          ><p style="position: relative; bottom: 60px" class="f14">
            暂无数据
          </p></el-empty
        >
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { trademarkquerykeyes } from "@/api/patent/patent.api";
import { followtrademarkfllow } from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      searchcont: true,
      maincont: false,
      input2: "",
      ruleForm: {
        query_type: "",
        trademark_name: "", //商标名称
        agent_name: "", //代理机构名称
        register: "", //注册人名称
        address: "", //注册人地址
        reg_number: "", //商标注册号
        international_class: "", //国际分类号
      },
      options: [
        {
          name: "精确查询",
          id: "eq",
        },
        {
          name: "模糊查询",
          id: "like",
        },
      ],
      thisNum: 1,
      pages: [],
      total: 0,
      currentPage: 0,
      serchkey: true,
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    changecont() {
      this.searchcont = false;
      this.maincont = true;
    },
    searchclick() {
      this.$loading.show(); // 显示loading
      trademarkquerykeyes({
        trademark_name: this.input2,
        query_type: "like",
        address: "",
        agent_name: "",
        register: "",
        reg_number: "",
        international_class: "",
        limit: 20,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("trademark_name", this.input2);
          this.searchcont = false;
          this.maincont = true;
          this.ruleForm.trademark_name = this.input2;
          this.ruleForm.query_type = "like";
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.IsWellKnown == "") {
                i.IsWellKnown = "否";
              }
            });
          }
          this.$message({
            showClose: true,
            message: "检索成功",
            type: "success",
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      if (
        window.sessionStorage.getItem("query_type") != null ||
        window.sessionStorage.getItem("trademark_name") != null ||
        window.sessionStorage.getItem("agent_name") != null ||
        window.sessionStorage.getItem("register") != null ||
        window.sessionStorage.getItem("addresst") != null ||
        window.sessionStorage.getItem("reg_number") != null ||
        window.sessionStorage.getItem("international_class") != null
      ) {
        this.searchcont = false;
        this.maincont = true;
        trademarkquerykeyes({
          query_type: window.sessionStorage.getItem("query_type"),
          trademark_name: window.sessionStorage.getItem("trademark_name"),
          agent_name: window.sessionStorage.getItem("agent_name"),
          register: window.sessionStorage.getItem("register"),
          address: window.sessionStorage.getItem("addresst"),
          reg_number: window.sessionStorage.getItem("reg_number"),
          international_class: window.sessionStorage.getItem(
            "international_class"
          ),
          limit: 20,
          page: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            if (
              this.pages == undefined ||
              this.pages == null ||
              this.pages == ""
            ) {
              this.total = 0;
            } else {
              this.pages.forEach((i) => {
                if (i.IsWellKnown == "") {
                  i.IsWellKnown = "否";
                }
              });
            }
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.total = 0;
      }
    },
    // 清空input
    resetForm() {
      this.ruleForm.trademark_name = "";
      this.ruleForm.query_type = "";
      this.ruleForm.address = "";
      this.ruleForm.agent_name = "";
      this.ruleForm.register = "";
      this.ruleForm.reg_number = "";
      this.ruleForm.international_class = "";
      this.pages = "";
      this.total = 0;
    },
    // 保存商标key
    todetails(row) {
      window.sessionStorage.setItem("item_key", row.ItemKey);
      this.$router.push({ path: "/Data-Homepage/Trademark-details" });
    },
    // 商标通过率检测
    toThroughrate() {
      this.$router.push({ path: "/intellectual-property/Through-rate" });
    },
    // 加入关注
    addteadmarkfollow(row) {
      followtrademarkfllow({ trademark_id: row.id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入关注",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 商标检索
    submitForm() {
      this.$loading.show(); // 显示loading
      window.sessionStorage.setItem(
        "trademark_name",
        this.ruleForm.trademark_name
      );
      window.sessionStorage.setItem("query_type", this.ruleForm.query_type);
      window.sessionStorage.setItem("addresst", this.ruleForm.address);
      window.sessionStorage.setItem("agent_name", this.ruleForm.agent_name);
      window.sessionStorage.setItem("register", this.ruleForm.register);
      window.sessionStorage.setItem("reg_number", this.ruleForm.reg_number);
      window.sessionStorage.setItem(
        "agent_name",
        this.ruleForm.international_class
      );
      trademarkquerykeyes({
        trademark_name: this.ruleForm.trademark_name,
        query_type: this.ruleForm.query_type,
        address: this.ruleForm.address,
        agent_name: this.ruleForm.agent_name,
        register: this.ruleForm.register,
        reg_number: this.ruleForm.reg_number,
        international_class: this.ruleForm.international_class,
        limit: 20,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.IsWellKnown == "") {
                i.IsWellKnown = "否";
              }
            });
          }
          this.$message({
            showClose: true,
            message: "检索成功",
            type: "success",
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      this.$loading.show(); // 显示loading
      trademarkquerykeyes({
        query_type: window.sessionStorage.getItem("query_type"),
        trademark_name: window.sessionStorage.getItem("trademark_name"),
        agent_name: window.sessionStorage.getItem("agent_name"),
        register: window.sessionStorage.getItem("register"),
        address: window.sessionStorage.getItem("addresst"),
        reg_number: window.sessionStorage.getItem("reg_number"),
        international_class: window.sessionStorage.getItem(
          "international_class"
        ),
        limit: val,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.IsWellKnown == "") {
                i.IsWellKnown = "否";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 分页
    currentchange(val) {
      this.$loading.show(); // 显示loading
      trademarkquerykeyes({
        query_type: window.sessionStorage.getItem("query_type"),
        trademark_name: window.sessionStorage.getItem("trademark_name"),
        agent_name: window.sessionStorage.getItem("agent_name"),
        register: window.sessionStorage.getItem("register"),
        address: window.sessionStorage.getItem("addresst"),
        reg_number: window.sessionStorage.getItem("reg_number"),
        international_class: window.sessionStorage.getItem(
          "international_class"
        ),
        limit: 20,
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.IsWellKnown == "") {
                i.IsWellKnown = "否";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    if (window.sessionStorage.getItem("query_type") != null) {
      this.ruleForm.query_type = window.sessionStorage.getItem("query_type");
    }
    if (window.sessionStorage.getItem("trademark_name") != null) {
      this.ruleForm.trademark_name =
        window.sessionStorage.getItem("trademark_name");
    }
    if (window.sessionStorage.getItem("agent_name") != null) {
      this.ruleForm.agent_name = window.sessionStorage.getItem("agent_name");
    }
    if (window.sessionStorage.getItem("register") != null) {
      this.ruleForm.register = window.sessionStorage.getItem("register");
    }
    if (window.sessionStorage.getItem("addresst") != null) {
      this.ruleForm.address = window.sessionStorage.getItem("addresst");
    }
    if (window.sessionStorage.getItem("reg_number") != null) {
      this.ruleForm.reg_number = window.sessionStorage.getItem("reg_number");
    }
    if (window.sessionStorage.getItem("international_class") != null) {
      this.ruleForm.international_class = window.sessionStorage.getItem(
        "international_class"
      );
    }
    this.$loading.show(); // 显示loading
    if (
      window.sessionStorage.getItem("query_type") != null ||
      window.sessionStorage.getItem("trademark_name") != null ||
      window.sessionStorage.getItem("agent_name") != null ||
      window.sessionStorage.getItem("register") != null ||
      window.sessionStorage.getItem("addresst") != null ||
      window.sessionStorage.getItem("reg_number") != null ||
      window.sessionStorage.getItem("international_class") != null
    ) {
      this.searchcont = false;
      this.maincont = true;
      trademarkquerykeyes({
        query_type: window.sessionStorage.getItem("query_type"),
        trademark_name: window.sessionStorage.getItem("trademark_name"),
        agent_name: window.sessionStorage.getItem("agent_name"),
        register: window.sessionStorage.getItem("register"),
        address: window.sessionStorage.getItem("addresst"),
        reg_number: window.sessionStorage.getItem("reg_number"),
        international_class: window.sessionStorage.getItem(
          "international_class"
        ),
        limit: 20,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          if (
            this.pages == undefined ||
            this.pages == null ||
            this.pages == ""
          ) {
            this.total = 0;
          } else {
            this.pages.forEach((i) => {
              if (i.IsWellKnown == "") {
                i.IsWellKnown = "否";
              }
            });
          }
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    } else {
      this.$loading.hide(); // 隐藏loading
      this.total = 0;
    }
  },
};
</script>
<style scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin: 10px 20px 10px 0;
  width: 20%;
}
.Keywordsinput >>> .el-input__inner {
  height: 50px;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 23px 0 0 23px;
  position: relative;
  left: 35%;
}
.Keywordsinput >>> .el-input-group__append,
.el-input-group__prepend {
  width: 60px;
  text-align: center;
  color: #fff;
  background: #52c5cb;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 0px 100px 100px 0px;
  position: relative;
  left: 25%;
  font-size: 16px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>